
import { ArgumentNullException } from '../../../../utility/exception/argument-null.exception';
import { IdValueObject } from '../../../../utility/model/id-value-object.model';

export class SharingVendorTs extends IdValueObject {
  static create(value: string): SharingVendorTs {
    if (value === null) {
      throw new ArgumentNullException();
    }
    return new SharingVendorTs(value);
  }
}
